import type { GeometryQuestion } from './geometryTestNY';

export const geometryTestTX: GeometryQuestion[] = [
  {
    id: 1, type: 'multiple-choice', points: 2,
    topic: 'Logical Reasoning', standard: 'TX.TEKS.G.4A',
    question: 'Which of the following is the converse of "If it is raining, then the ground is wet"?',
    options: [
      'If the ground is not wet, then it is not raining.',
      'If the ground is wet, then it is raining.',
      'If it is not raining, then the ground is not wet.',
      'It is raining and the ground is wet.'
    ],
    correctAnswer: 1,
    solution: [
      'The converse of "If P, then Q" is "If Q, then P."',
      'Original: If it is raining (P), then the ground is wet (Q).',
      'Converse: If the ground is wet (Q), then it is raining (P).',
      'Answer: If the ground is wet, then it is raining.'
    ]
  },
  {
    id: 2, type: 'multiple-choice', points: 2,
    topic: 'Segment Addition', standard: 'TX.TEKS.G.2A',
    question: 'Points A, B, and C are collinear with B between A and C. If AB = 3x + 2, BC = x + 6, and AC = 24, what is x?',
    options: ['x = 4', 'x = 3', 'x = 5', 'x = 2'],
    correctAnswer: 0,
    solution: [
      'Segment Addition Postulate: AB + BC = AC',
      '(3x + 2) + (x + 6) = 24',
      '4x + 8 = 24',
      '4x = 16',
      'x = 4',
      'Answer: x = 4'
    ]
  },
  {
    id: 3, type: 'multiple-choice', points: 2,
    topic: 'Parallel Lines & Transversals', standard: 'TX.TEKS.G.5A',
    question: 'Two parallel lines are cut by a transversal. Corresponding angles measure (4x + 10)° and (6x − 20)°. What is x?',
    options: ['x = 15', 'x = 10', 'x = 20', 'x = 5'],
    correctAnswer: 0,
    solution: [
      'Corresponding angles are congruent when lines are parallel.',
      '4x + 10 = 6x − 20',
      '10 + 20 = 6x − 4x',
      '30 = 2x',
      'x = 15',
      'Answer: x = 15'
    ]
  },
  {
    id: 4, type: 'multiple-choice', points: 2,
    topic: 'Triangle Congruence', standard: 'TX.TEKS.G.6B',
    question: 'In triangles ABC and DEF, angle A ≅ angle D, angle B ≅ angle E, and AB ≅ DE. Which postulate proves congruence?',
    options: ['SSS', 'SAS', 'ASA', 'AAS'],
    correctAnswer: 2,
    solution: [
      'ASA (Angle-Side-Angle): two angles and the included side are congruent.',
      'Angle A ≅ Angle D, AB ≅ DE (included side), Angle B ≅ Angle E.',
      'Answer: ASA'
    ]
  },
  {
    id: 5, type: 'multiple-choice', points: 2,
    topic: 'Pythagorean Theorem', standard: 'TX.TEKS.G.9B',
    question: 'A right triangle has a hypotenuse of 26 and one leg of 10. What is the other leg?',
    options: ['24', '16', '28', '√576'],
    correctAnswer: 0,
    solution: [
      'a² + b² = c²',
      '10² + b² = 26²',
      '100 + b² = 676',
      'b² = 576',
      'b = 24',
      'Answer: 24'
    ]
  },
  {
    id: 6, type: 'multiple-choice', points: 2,
    topic: 'Trigonometry', standard: 'TX.TEKS.G.9A',
    question: 'In right triangle ABC with right angle at C, if cos(A) = 5/13, what is sin(A)?',
    options: ['12/13', '5/12', '13/12', '5/13'],
    correctAnswer: 0,
    solution: [
      'cos(A) = adjacent/hypotenuse = 5/13, so adjacent = 5, hypotenuse = 13.',
      'Use Pythagorean Theorem: opposite² = 13² − 5² = 169 − 25 = 144',
      'opposite = 12',
      'sin(A) = opposite/hypotenuse = 12/13',
      'Answer: 12/13'
    ]
  },
  {
    id: 7, type: 'multiple-choice', points: 2,
    topic: 'Coordinate Geometry', standard: 'TX.TEKS.G.2B',
    question: 'What is the midpoint of the segment from (−4, 2) to (8, −6)?',
    options: ['(2, −2)', '(4, −4)', '(2, 2)', '(−2, 4)'],
    correctAnswer: 0,
    solution: [
      'Midpoint = ((x₁+x₂)/2, (y₁+y₂)/2)',
      'M = ((−4+8)/2, (2+(−6))/2)',
      'M = (4/2, −4/2)',
      'M = (2, −2)',
      'Answer: (2, −2)'
    ]
  },
  {
    id: 8, type: 'multiple-choice', points: 2,
    topic: 'Area of Sector', standard: 'TX.TEKS.G.12B',
    question: 'A circle has radius 12. What is the area of a sector with central angle 120°?',
    options: ['48π', '144π', '24π', '36π'],
    correctAnswer: 0,
    solution: [
      'Sector area = (θ/360°) × πr²',
      'Sector area = (120/360) × π(12)²',
      'Sector area = (1/3) × 144π',
      'Sector area = 48π',
      'Answer: 48π'
    ]
  },
  {
    id: 9, type: 'multiple-choice', points: 2,
    topic: 'Volume of Cone', standard: 'TX.TEKS.G.11B',
    question: 'A cone has radius 6 and height 8. What is its volume?',
    options: ['96π', '288π', '48π', '144π'],
    correctAnswer: 0,
    solution: [
      'Volume of a cone = (1/3)πr²h',
      'V = (1/3)π(6)²(8)',
      'V = (1/3)π(36)(8)',
      'V = (1/3)(288π)',
      'V = 96π',
      'Answer: 96π'
    ]
  },
  {
    id: 10, type: 'multiple-choice', points: 2,
    topic: 'Similarity', standard: 'TX.TEKS.G.7A',
    question: 'The areas of two similar triangles are 16 and 36. What is the ratio of their corresponding sides?',
    options: ['4:6', '2:3', '4:9', '16:36'],
    correctAnswer: 1,
    solution: [
      'The ratio of areas of similar figures = (ratio of sides)²',
      '16/36 = (side ratio)²',
      'side ratio = √(16/36) = 4/6 = 2/3',
      'Answer: 2:3'
    ]
  },
  {
    id: 11, type: 'multiple-choice', points: 2,
    topic: 'Transformations', standard: 'TX.TEKS.G.3A',
    question: 'Triangle ABC is reflected over the y-axis. If A = (3, 4), what is A\'?',
    options: ['(−3, 4)', '(3, −4)', '(−3, −4)', '(4, 3)'],
    correctAnswer: 0,
    solution: [
      'Reflection over the y-axis: (x, y) → (−x, y)',
      'A(3, 4) → A\'(−3, 4)',
      'Answer: (−3, 4)'
    ]
  },
  {
    id: 12, type: 'multiple-choice', points: 2,
    topic: 'Inscribed Angles', standard: 'TX.TEKS.G.12A',
    question: 'Two inscribed angles in the same circle intercept the same arc. What is true about these angles?',
    options: ['They are supplementary', 'They are complementary', 'They are congruent', 'They are vertical angles'],
    correctAnswer: 2,
    solution: [
      'Inscribed Angle Theorem: inscribed angles that intercept the same arc are congruent.',
      'Both angles equal half the intercepted arc.',
      'Answer: They are congruent'
    ]
  },
  {
    id: 13, type: 'multiple-choice', points: 2,
    topic: 'Perimeter of Similar Figures', standard: 'TX.TEKS.G.7B',
    question: 'Two similar rectangles have a scale factor of 3:7. If the perimeter of the smaller is 24, what is the perimeter of the larger?',
    options: ['56', '168', '8', '72'],
    correctAnswer: 0,
    solution: [
      'Perimeters of similar figures are proportional to the scale factor.',
      '3/7 = 24/P',
      'P = 24 × 7/3 = 56',
      'Answer: 56'
    ]
  },
  {
    id: 14, type: 'multiple-choice', points: 2,
    topic: 'Angle Sum of Triangle', standard: 'TX.TEKS.G.6A',
    question: 'In triangle PQR, angle P = (2x + 10)°, angle Q = (3x − 5)°, angle R = (x + 15)°. What is x?',
    options: ['x = 27', 'x = 26', 'x = 30', 'x = 20'],
    correctAnswer: 0,
    solution: [
      'Sum of angles in a triangle = 180°',
      '(2x + 10) + (3x − 5) + (x + 15) = 180',
      '6x + 20 = 180',
      '6x = 160',
      'x = 160/6 ≈ 26.7 → closest is 27',
      'Answer: x = 27'
    ]
  },
  {
    id: 15, type: 'multiple-choice', points: 2,
    topic: 'Equation of Circle', standard: 'TX.TEKS.G.12E',
    question: 'What is the center and radius of the circle (x + 5)² + (y − 2)² = 49?',
    options: ['Center (5, −2), r = 7', 'Center (−5, 2), r = 7', 'Center (−5, 2), r = 49', 'Center (5, 2), r = 7'],
    correctAnswer: 1,
    solution: [
      'Standard form: (x − h)² + (y − k)² = r²',
      '(x + 5)² = (x − (−5))², so h = −5',
      '(y − 2)², so k = 2',
      'r² = 49, so r = 7',
      'Center: (−5, 2), radius: 7',
      'Answer: Center (−5, 2), r = 7'
    ]
  },
  {
    id: 16, type: 'multiple-choice', points: 2,
    topic: 'Special Right Triangles', standard: 'TX.TEKS.G.9C',
    question: 'In a 30-60-90 triangle, the shorter leg is 5. What is the hypotenuse?',
    options: ['5√3', '10', '5√2', '10√3'],
    correctAnswer: 1,
    solution: [
      'In a 30-60-90 triangle: shorter leg : longer leg : hypotenuse = 1 : √3 : 2',
      'Shorter leg = 5, so hypotenuse = 2 × 5 = 10',
      'Answer: 10'
    ]
  },
  {
    id: 17, type: 'multiple-choice', points: 2,
    topic: 'Dilation', standard: 'TX.TEKS.G.3C',
    question: 'A segment of length 8 is dilated by a scale factor of 2.5. What is the new length?',
    options: ['10', '20', '5.5', '16'],
    correctAnswer: 1,
    solution: [
      'New length = original length × scale factor',
      'New length = 8 × 2.5 = 20',
      'Answer: 20'
    ]
  },
  {
    id: 18, type: 'multiple-choice', points: 2,
    topic: 'Quadrilateral Properties', standard: 'TX.TEKS.G.6E',
    question: 'In rectangle ABCD, the diagonals AC and BD intersect at E. If AC = 18, what is AE?',
    options: ['18', '9', '6', '36'],
    correctAnswer: 1,
    solution: [
      'In a rectangle, the diagonals are equal in length and bisect each other.',
      'AE = AC / 2 = 18 / 2 = 9',
      'Answer: 9'
    ]
  },
  {
    id: 19, type: 'multiple-choice', points: 2,
    topic: 'Surface Area of Cylinder', standard: 'TX.TEKS.G.11C',
    question: 'What is the total surface area of a cylinder with radius 5 and height 12?',
    options: ['170π', '120π', '50π', '60π'],
    correctAnswer: 0,
    solution: [
      'Total SA of cylinder = 2πr² + 2πrh',
      'SA = 2π(5)² + 2π(5)(12)',
      'SA = 2π(25) + 2π(60)',
      'SA = 50π + 120π = 170π',
      'Answer: 170π'
    ]
  },
  {
    id: 20, type: 'multiple-choice', points: 2,
    topic: 'Angle of Depression', standard: 'TX.TEKS.G.9D',
    question: 'From the top of a 40-foot cliff, the angle of depression to a boat is 30°. How far is the boat from the base of the cliff?',
    options: ['40√3', '40/√3', '20√3', '80'],
    correctAnswer: 0,
    solution: [
      'The angle of depression = angle of elevation from the boat.',
      'tan(30°) = 40 / distance',
      '1/√3 = 40 / distance',
      'distance = 40√3',
      'Answer: 40√3 feet'
    ]
  },
  {
    id: 21, type: 'multiple-choice', points: 2,
    topic: 'Polygon Interior Angles', standard: 'TX.TEKS.G.6A',
    question: 'Each interior angle of a regular polygon measures 150°. How many sides does it have?',
    options: ['10', '12', '8', '15'],
    correctAnswer: 1,
    solution: [
      'Interior angle of regular polygon = (n−2)×180° / n',
      '150 = (n−2)×180 / n',
      '150n = 180n − 360',
      '360 = 30n',
      'n = 12',
      'Answer: 12 sides'
    ]
  },
  {
    id: 22, type: 'multiple-choice', points: 2,
    topic: 'Coordinate Proof', standard: 'TX.TEKS.G.2C',
    question: 'To prove a quadrilateral is a parallelogram using coordinates, you should show:',
    options: [
      'All four sides are equal',
      'Both pairs of opposite sides are parallel (equal slopes)',
      'All angles are 90°',
      'The diagonals are equal'
    ],
    correctAnswer: 1,
    solution: [
      'A parallelogram has both pairs of opposite sides parallel.',
      'In coordinate geometry, parallel lines have equal slopes.',
      'Show slope of AB = slope of DC, and slope of AD = slope of BC.',
      'Answer: Both pairs of opposite sides are parallel (equal slopes)'
    ]
  },
  {
    id: 23, type: 'multiple-choice', points: 2,
    topic: 'Circumference', standard: 'TX.TEKS.G.12B',
    question: 'A circle has circumference 20π. What is its area?',
    options: ['100π', '400π', '10π', '40π'],
    correctAnswer: 0,
    solution: [
      'Circumference = 2πr = 20π, so r = 10',
      'Area = πr² = π(10)² = 100π',
      'Answer: 100π'
    ]
  },
  {
    id: 24, type: 'multiple-choice', points: 2,
    topic: 'Geometric Mean', standard: 'TX.TEKS.G.9B',
    question: 'What is the geometric mean of 4 and 25?',
    options: ['10', '14.5', '100', '√29'],
    correctAnswer: 0,
    solution: [
      'Geometric mean of a and b = √(a × b)',
      'Geometric mean = √(4 × 25) = √100 = 10',
      'Answer: 10'
    ]
  },
  {
    id: 25, type: 'multiple-choice', points: 2,
    topic: 'Translations', standard: 'TX.TEKS.G.3A',
    question: 'Point K(2, −3) is translated by the vector (−4, 7). What are the new coordinates?',
    options: ['(−2, 4)', '(6, −10)', '(−2, −10)', '(6, 4)'],
    correctAnswer: 0,
    solution: [
      'Translation: add the vector components to the coordinates.',
      'K\' = (2 + (−4), −3 + 7)',
      'K\' = (−2, 4)',
      'Answer: (−2, 4)'
    ]
  },
  {
    id: 26, type: 'multiple-choice', points: 2,
    topic: 'Kite Properties', standard: 'TX.TEKS.G.6E',
    question: 'In a kite, which of the following is always true?',
    options: [
      'All four sides are equal',
      'The diagonals are equal',
      'One diagonal is the perpendicular bisector of the other',
      'Opposite angles are all equal'
    ],
    correctAnswer: 2,
    solution: [
      'In a kite, one diagonal (the "main" diagonal) is the perpendicular bisector of the other.',
      'The diagonals are perpendicular, and the main diagonal bisects the other.',
      'Answer: One diagonal is the perpendicular bisector of the other'
    ]
  },
  {
    id: 27, type: 'multiple-choice', points: 2,
    topic: 'Volume of Prism', standard: 'TX.TEKS.G.11B',
    question: 'A triangular prism has a triangular base with base 6 and height 4, and the prism height is 10. What is the volume?',
    options: ['120', '240', '60', '180'],
    correctAnswer: 0,
    solution: [
      'Volume of prism = Base Area × Height',
      'Base area (triangle) = (1/2)(6)(4) = 12',
      'Volume = 12 × 10 = 120',
      'Answer: 120'
    ]
  },
  {
    id: 28, type: 'multiple-choice', points: 2,
    topic: 'Conditional Statements', standard: 'TX.TEKS.G.4B',
    question: 'What is the contrapositive of "If a polygon is a square, then it is a rectangle"?',
    options: [
      'If it is a rectangle, then it is a square.',
      'If it is not a square, then it is not a rectangle.',
      'If it is not a rectangle, then it is not a square.',
      'If it is a rectangle, then it is not a square.'
    ],
    correctAnswer: 2,
    solution: [
      'Contrapositive of "If P, then Q" is "If not Q, then not P."',
      'P = polygon is a square; Q = it is a rectangle',
      'Contrapositive: If it is NOT a rectangle, then it is NOT a square.',
      'Answer: If it is not a rectangle, then it is not a square.'
    ]
  },
  {
    id: 29, type: 'multiple-choice', points: 2,
    topic: 'Density', standard: 'TX.TEKS.G.11D',
    question: 'A gold bar has volume 50 cm³ and mass 965 g. What is its density?',
    options: ['19.3 g/cm³', '48250 g/cm³', '0.052 g/cm³', '915 g/cm³'],
    correctAnswer: 0,
    solution: [
      'Density = mass / volume',
      'Density = 965 / 50 = 19.3 g/cm³',
      'Answer: 19.3 g/cm³'
    ]
  },
  {
    id: 30, type: 'multiple-choice', points: 2,
    topic: 'Nets of 3D Figures', standard: 'TX.TEKS.G.10A',
    question: 'A net of a rectangular prism consists of how many rectangles?',
    options: ['4', '5', '6', '8'],
    correctAnswer: 2,
    solution: [
      'A rectangular prism has 6 faces: top, bottom, front, back, left, right.',
      'Its net consists of 6 rectangles (some may be squares).',
      'Answer: 6'
    ]
  }
];
